import { atom } from 'nanostores';
import type { SourceProposedActionT } from '@/shared/lib';

export interface RxWizardPrefill {
  kind: 'coded';
  dispensableDrugId: number;
  directions: string;
  quantity: string;
  refills: string;
  daysSupply: string;
  pharmacyNotes?: string;
  noSubstitutions?: boolean;
  effectiveDate?: string; // YYYY-MM-DD
  sourceProposedAction?: SourceProposedActionT;
}

/**
 * One-shot prefill payload for the RxWizard overlay.
 *
 * This is intentionally stored in-memory and is consumed once by the RxWizard
 * when it mounts/opens. Do not persist this value.
 */
export const $rxWizardPrefill = atom<RxWizardPrefill | null>(null);

export function setRxWizardPrefill(prefill: RxWizardPrefill) {
  $rxWizardPrefill.set(prefill);
}

export function clearRxWizardPrefill() {
  $rxWizardPrefill.set(null);
}
